export default Object.freeze({
  MOBILE: 'mobile',
  WORK: 'work',
  HOME: 'home',
});
